import React from 'react';
import { useIntl } from 'react-intl';

import { ReactFCV } from '@types';

import { IMedicinalProductLabelMessages } from '../../model';

import { StyledMedicinalProductLabel } from './styled';

export const MedicinalProductLabel: ReactFCV<IMedicinalProductLabelMessages> = ({ message }) => {
  const { formatMessage } = useIntl();

  if (!message) {
    return null;
  }

  return (
    <StyledMedicinalProductLabel>
      <div dangerouslySetInnerHTML={{ __html: formatMessage(message) }} />
    </StyledMedicinalProductLabel>
  );
};
